import myApi from '@/util/api'

export function getNotification(id) {
  return myApi.getByID(id, 'Notification/GetNotifications')
}
export function updateNotification(data) {

  return myApi.update(data.notificationId, data, "Notification/UpdateNotification")
}


// WEBPACK FOOTER //
// ./src/api/notification.js